export interface SnowForecast {
  id: string
  clientId: string
  eventStart: Date
  eventEnd: Date
  accumulation: {
    min: number
    max: number
    median: number
  }
  probability: number
  intensity: 'légère' | 'modérée' | 'forte'
  type: 'neige' | 'verglas' | 'mixte'
  temperature: number
  windSpeed: number
  status: 'prévu' | 'en_cours' | 'terminé'
  triggeredIntervention: boolean
  createdAt: Date
  updatedAt: Date
}
// Génération de prévisions pour les prochains jours
const now = new Date()
const tomorrow = new Date(now)
tomorrow.setDate(tomorrow.getDate() + 1)
tomorrow.setHours(2, 0, 0, 0)
const dayAfter = new Date(now)
dayAfter.setDate(dayAfter.getDate() + 2)
dayAfter.setHours(14, 0, 0, 0)
const threeDays = new Date(now)
threeDays.setDate(threeDays.getDate() + 3)
threeDays.setHours(22, 0, 0, 0)
export const forecasts: SnowForecast[] = [
  // Événement demain matin - Forte neige
  {
    id: 'FC-001',
    clientId: 'CLT-001',
    eventStart: new Date(tomorrow.getTime()),
    eventEnd: new Date(tomorrow.getTime() + 6 * 60 * 60 * 1000),
    accumulation: { min: 8, max: 12, median: 10 },
    probability: 85,
    intensity: 'forte',
    type: 'neige',
    temperature: -8,
    windSpeed: 25,
    status: 'prévu',
    triggeredIntervention: true,
    createdAt: now,
    updatedAt: now,
  },
  {
    id: 'FC-002',
    clientId: 'CLT-002',
    eventStart: new Date(tomorrow.getTime()),
    eventEnd: new Date(tomorrow.getTime() + 6 * 60 * 60 * 1000),
    accumulation: { min: 9, max: 13, median: 11 },
    probability: 88,
    intensity: 'forte',
    type: 'neige',
    temperature: -8,
    windSpeed: 25,
    status: 'prévu',
    triggeredIntervention: true,
    createdAt: now,
    updatedAt: now,
  },
  {
    id: 'FC-003',
    clientId: 'CLT-003',
    eventStart: new Date(tomorrow.getTime()),
    eventEnd: new Date(tomorrow.getTime() + 5 * 60 * 60 * 1000),
    accumulation: { min: 7, max: 11, median: 9 },
    probability: 82,
    intensity: 'forte',
    type: 'neige',
    temperature: -7,
    windSpeed: 22,
    status: 'prévu',
    triggeredIntervention: true,
    createdAt: now,
    updatedAt: now,
  },
  {
    id: 'FC-004',
    clientId: 'CLT-004',
    eventStart: new Date(tomorrow.getTime() + 1 * 60 * 60 * 1000),
    eventEnd: new Date(tomorrow.getTime() + 7 * 60 * 60 * 1000),
    accumulation: { min: 10, max: 14, median: 12 },
    probability: 90,
    intensity: 'forte',
    type: 'neige',
    temperature: -9,
    windSpeed: 28,
    status: 'prévu',
    triggeredIntervention: true,
    createdAt: now,
    updatedAt: now,
  },
  {
    id: 'FC-005',
    clientId: 'CLT-005',
    eventStart: new Date(tomorrow.getTime() + 2 * 60 * 60 * 1000),
    eventEnd: new Date(tomorrow.getTime() + 8 * 60 * 60 * 1000),
    accumulation: { min: 6, max: 10, median: 8 },
    probability: 78,
    intensity: 'modérée',
    type: 'neige',
    temperature: -7,
    windSpeed: 20,
    status: 'prévu',
    triggeredIntervention: true,
    createdAt: now,
    updatedAt: now,
  },
  // Événement après-demain - Neige modérée avec verglas
  {
    id: 'FC-006',
    clientId: 'CLT-006',
    eventStart: new Date(dayAfter.getTime()),
    eventEnd: new Date(dayAfter.getTime() + 4 * 60 * 60 * 1000),
    accumulation: { min: 3, max: 6, median: 4 },
    probability: 75,
    intensity: 'modérée',
    type: 'mixte',
    temperature: -2,
    windSpeed: 15,
    status: 'prévu',
    triggeredIntervention: true,
    createdAt: now,
    updatedAt: now,
  },
  {
    id: 'FC-007',
    clientId: 'CLT-007',
    eventStart: new Date(dayAfter.getTime()),
    eventEnd: new Date(dayAfter.getTime() + 5 * 60 * 60 * 1000),
    accumulation: { min: 4, max: 7, median: 5 },
    probability: 80,
    intensity: 'modérée',
    type: 'mixte',
    temperature: -2,
    windSpeed: 18,
    status: 'prévu',
    triggeredIntervention: true,
    createdAt: now,
    updatedAt: now,
  },
  {
    id: 'FC-008',
    clientId: 'CLT-008',
    eventStart: new Date(dayAfter.getTime() - 1 * 60 * 60 * 1000),
    eventEnd: new Date(dayAfter.getTime() + 4 * 60 * 60 * 1000),
    accumulation: { min: 5, max: 8, median: 6 },
    probability: 85,
    intensity: 'modérée',
    type: 'mixte',
    temperature: -3,
    windSpeed: 20,
    status: 'prévu',
    triggeredIntervention: true,
    createdAt: now,
    updatedAt: now,
  },
  // Événement dans 3 jours - Neige légère nocturne
  {
    id: 'FC-009',
    clientId: 'CLT-009',
    eventStart: new Date(threeDays.getTime()),
    eventEnd: new Date(threeDays.getTime() + 3 * 60 * 60 * 1000),
    accumulation: { min: 2, max: 4, median: 3 },
    probability: 65,
    intensity: 'légère',
    type: 'neige',
    temperature: -5,
    windSpeed: 12,
    status: 'prévu',
    triggeredIntervention: false,
    createdAt: now,
    updatedAt: now,
  },
  {
    id: 'FC-010',
    clientId: 'CLT-010',
    eventStart: new Date(threeDays.getTime()),
    eventEnd: new Date(threeDays.getTime() + 4 * 60 * 60 * 1000),
    accumulation: { min: 2, max: 5, median: 3 },
    probability: 68,
    intensity: 'légère',
    type: 'neige',
    temperature: -6,
    windSpeed: 10,
    status: 'prévu',
    triggeredIntervention: false,
    createdAt: now,
    updatedAt: now,
  },
  {
    id: 'FC-011',
    clientId: 'CLT-011',
    eventStart: new Date(threeDays.getTime()),
    eventEnd: new Date(threeDays.getTime() + 3 * 60 * 60 * 1000),
    accumulation: { min: 3, max: 5, median: 4 },
    probability: 70,
    intensity: 'légère',
    type: 'neige',
    temperature: -5,
    windSpeed: 13,
    status: 'prévu',
    triggeredIntervention: true,
    createdAt: now,
    updatedAt: now,
  },
  {
    id: 'FC-012',
    clientId: 'CLT-012',
    eventStart: new Date(threeDays.getTime() + 1 * 60 * 60 * 1000),
    eventEnd: new Date(threeDays.getTime() + 4 * 60 * 60 * 1000),
    accumulation: { min: 1, max: 3, median: 2 },
    probability: 60,
    intensity: 'légère',
    type: 'neige',
    temperature: -4,
    windSpeed: 8,
    status: 'prévu',
    triggeredIntervention: false,
    createdAt: now,
    updatedAt: now,
  },
]
